import React, { useState } from "react";

/**
 * ImageWithFallback — a thumbnail <img> that never breaks the layout.
 * Shows a shimmering placeholder until the image finishes loading, and
 * a static "broken image" placeholder box if it fails to load (or the
 * src is empty) — instead of a browser broken-image icon or a collapsed
 * cell.
 */
const ImageWithFallback = ({
  src,
  alt = "",
  className = "hv-40 bg-light rounded-2",
  style,
  wrapperStyle,
}) => {
  const [state, setState] = useState(src ? "loading" : "empty");

  if (state === "empty" || state === "error" || !src) {
    return (
      <div
        className={`d-flex align-items-center justify-content-center bg-light rounded-2 text-muted ${className}`}
        style={{ minWidth: 40, ...style, ...wrapperStyle }}
        title={state === "error" ? "Failed to load image" : "No image"}
      >
        <i className={`bx ${state === "error" ? "bx-image-alt" : "bx-image"}`} style={{ fontSize: 16 }}></i>
      </div>
    );
  }

  return (
    <div className="position-relative d-inline-block" style={wrapperStyle}>
      {state === "loading" && (
        <span
          className={`d-block position-absolute top-0 start-0 ${className}`}
          style={{
            background: "linear-gradient(90deg,#eceff1 25%,#f5f6f7 37%,#eceff1 63%)",
            backgroundSize: "400% 100%",
            animation: "tmShimmer 1.4s ease infinite",
            ...style,
          }}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        style={{ ...style, opacity: state === "loading" ? 0 : 1 }}
        onLoad={() => setState("loaded")}
        onError={() => setState("error")}
      />
    </div>
  );
};

export default ImageWithFallback;
